// extracted by mini-css-extract-plugin
export var avatarContainer = "_4x-0";
export var avatarTypingWave = "_4x-i";
export var gray = "_4x-f";
export var green = "_4x-c";
export var icon = "_4x-9";
export var image = "_4x-1";
export var lg = "_4x-6";
export var md = "_4x-5";
export var presenceDot = "_4x-b";
export var red = "_4x-d";
export var sm = "_4x-4";
export var status = "_4x-a";
export var typingDot = "_4x-h";
export var typingPill = "_4x-g";
export var xl = "_4x-7";
export var xs = "_4x-3";
export var xxl = "_4x-8";
export var xxs = "_4x-2";
export var yellow = "_4x-e";